import { apiPathToPlatform, mapToFrontPlatform } from 'utils';
import { categories as allCategories } from 'components/filters/components/content-category-filter/categories';
import { dashboardInitialState } from './dashboard.initialState';

export const streamAdaptor = (data) => {
  const {
    filter_type,
    id,
    title,
    type,
    params: {
      api_path,
      platforms = [],
      query = '',
      extracted_hashtags = [],
      resource_ids = [],
      not_resource_ids = [],
      tag_id = undefined,
      content_tag_ids = [],
      extracted_phrases = [],
      langs = [],
      sentiments = [],
      m3_age = [],
      gender = [],
      media_types = [],
      categories = [],
      sub_categories = [],
      resource_influence_categories = [],
      min_view = null,
      max_view = null,
      min_like = null,
      max_like = null,
      min_reactions = null,
      max_reactions = null,
      min_copy = null,
      max_copy = null,
      min_comment = null,
      max_comment = null,
    },
  } = data;

  const categoriesObject = {};
  if (sub_categories.length > 0 && categories.length > 0) {
    categories.forEach((category) => {
      categoriesObject[category] = sub_categories.filter((subCategory) =>
        allCategories[category].includes(subCategory)
      );
    });
  }

  const platform = apiPathToPlatform[api_path];

  const finalStream = {
    ...dashboardInitialState.stream,
    streamId: id,
    filterType: filter_type,
    title: title,
    type: type,
    params: {
      ...dashboardInitialState.stream.params,
      platforms:
        platform === 'multiPlatform'
          ? platforms.map((platform) => mapToFrontPlatform[platform])
          : [platform],
      query: query,
    },
  };

  const finalFilters = {};

  const currentFilters = dashboardInitialState.filters[platform];

  if (currentFilters?.contentTagFilter) {
    finalFilters.contentTagFilter = {
      ...currentFilters?.contentTagFilter,
      selectedIds: content_tag_ids,
      hasFilter: content_tag_ids.length > 0,
    };
  }
  if (currentFilters?.wordCloudFilter) {
    finalFilters.wordCloudFilter = {
      ...currentFilters?.wordCloudFilter,
      selectedIds: extracted_phrases,
      hasFilter: extracted_phrases.length > 0,
    };
  }
  if (currentFilters?.hashtagCloudFilter) {
    finalFilters.hashtagCloudFilter = {
      ...currentFilters?.hashtagCloudFilter,
      selectedIds: extracted_hashtags,
      hasFilter: extracted_hashtags.length > 0,
    };
  }
  if (currentFilters?.resourceCategoryFilter) {
    finalFilters.resourceCategoryFilter = {
      ...currentFilters?.resourceCategoryFilter,
      selectedValue: tag_id,
      hasFilter: !!tag_id,
    };
  }
  if (currentFilters?.languageFilter) {
    finalFilters.languageFilter = {
      ...currentFilters?.languageFilter,
      selectedValue: langs.length > 0 ? langs[0] : 'all',
      hasFilter: langs.length > 0,
    };
  }
  if (currentFilters?.resourcesFilter) {
    finalFilters.resourcesFilter = {
      ...currentFilters?.resourcesFilter,
      selectedValue: not_resource_ids?.length > 0 ? 'exclude' : 'include',
      selectedItems:
        resource_ids?.length > 0
          ? resource_ids.reduce((acc, id) => {
              acc[id] = { id, title: id };
              return acc;
            }, {})
          : not_resource_ids.reduce((acc, id) => {
              acc[id] = { id, title: id };
              return acc;
            }, {}),
      hasFilter: resource_ids?.length > 0 || not_resource_ids?.length > 0,
    };
  }

  if (currentFilters?.sentimentFilter) {
    finalFilters.sentimentFilter = {
      ...currentFilters?.sentimentFilter,
      selectedValues: sentiments.reduce((acc, sentiment) => {
        acc[sentiment] = true;
        return acc;
      }, {}),
      hasFilter: sentiments.length > 0,
    };
  }
  if (currentFilters?.ageFilter) {
    finalFilters.ageFilter = {
      ...currentFilters?.ageFilter,
      selectedIds: m3_age,
      hasFilter: m3_age.length > 0,
    };
  }
  if (currentFilters?.genderFilter) {
    finalFilters.genderFilter = {
      ...currentFilters?.genderFilter,
      selectedIds: gender,
      hasFilter: gender.length > 0,
    };
  }
  if (currentFilters?.contentCategoryFilter) {
    finalFilters.contentCategoryFilter = {
      ...currentFilters?.contentCategoryFilter,
      selectedCategories: categoriesObject,
      hasFilter: sub_categories.length > 0 && categories.length > 0,
    };
  }

  if (currentFilters?.mediaTypeFilter) {
    finalFilters.mediaTypeFilter = {
      ...currentFilters?.mediaTypeFilter,
      selectedIds: media_types,
      hasFilter: media_types.length > 0,
    };
  }

  if (platform === 'news') {
    if (currentFilters?.resourceTypeFilter) {
      finalFilters.resourceTypeFilter = {
        ...currentFilters?.resourceTypeFilter,
        selectedIds: media_types,
        hasFilter: media_types.length > 0,
      };
    }
    if (currentFilters?.contentBasedFilter) {
      finalFilters.contentBasedFilter = {
        ...currentFilters?.contentBasedFilter,
        selectedObjects: {
          influenceRate: {
            ...currentFilters?.contentBasedFilter?.selectedObjects
              ?.influenceRate,
            active: resource_influence_categories.length > 0,
            selectedIds: resource_influence_categories,
          },
        },
        hasFilter: resource_influence_categories.length > 0,
      };
    }
  }

  if (platform === 'instagram' && currentFilters?.contentBasedFilter) {
    finalFilters.contentBasedFilter = {
      ...currentFilters?.contentBasedFilter,
      selectedObjects: {
        influenceRate: {
          ...currentFilters?.contentBasedFilter?.selectedObjects.influenceRate,
          active: resource_influence_categories.length > 0,
          selectedIds: resource_influence_categories,
        },
        like: {
          ...currentFilters?.contentBasedFilter?.selectedObjects?.like,
          active: min_like || max_like,
          max: max_like,
          min: min_like,
        },
        comment: {
          ...currentFilters?.contentBasedFilter?.selectedObjects.comment,
          active: min_comment || max_comment,
          max: max_comment,
          min: min_comment,
        },
      },
      hasFilter:
        resource_influence_categories.length > 0 ||
        min_like ||
        max_like ||
        min_comment ||
        max_comment,
    };
  }

  if (platform === 'twitter' && currentFilters?.contentBasedFilter) {
    finalFilters.contentBasedFilter = {
      ...currentFilters?.contentBasedFilter,
      selectedObjects: {
        influenceRate: {
          ...currentFilters?.contentBasedFilter?.selectedObjects?.influenceRate,
          active: resource_influence_categories.length > 0,
          selectedIds: resource_influence_categories,
        },
        like: {
          ...currentFilters?.contentBasedFilter?.selectedObjects?.like,
          active: min_like || max_like,
          max: max_like,
          min: min_like,
        },
        copy: {
          ...currentFilters?.contentBasedFilter?.selectedObjects?.copy,
          active: min_copy || max_copy,
          max: max_copy,
          min: min_copy,
        },
      },
      hasFilter:
        resource_influence_categories.length > 0 ||
        min_like ||
        max_like ||
        min_copy ||
        max_copy,
    };
  }

  if (platform === 'virasty' && currentFilters?.contentBasedFilter) {
    finalFilters.contentBasedFilter = {
      ...currentFilters?.contentBasedFilter,
      selectedObjects: {
        influenceRate: {
          ...currentFilters?.contentBasedFilter?.selectedObjects?.influenceRate,
          active: resource_influence_categories.length > 0,
          selectedIds: resource_influence_categories,
        },
        reaction: {
          ...currentFilters?.contentBasedFilter?.selectedObjects?.reaction,
          active: min_reactions || max_reactions,
          max: max_reactions,
          min: min_reactions,
        },
        copy: {
          ...currentFilters?.contentBasedFilter?.selectedObjects?.copy,
          active: min_copy || max_copy,
          max: max_copy,
          min: min_copy,
        },
      },
      hasFilter:
        resource_influence_categories.length > 0 ||
        min_reactions ||
        max_reactions ||
        min_copy ||
        max_copy,
    };
  }

  if (platform === 'telegram' && currentFilters?.contentBasedFilter) {
    finalFilters.contentBasedFilter = {
      ...currentFilters?.contentBasedFilter,
      selectedObjects: {
        influenceRate: {
          ...currentFilters?.contentBasedFilter?.selectedObjects?.influenceRate,
          active: resource_influence_categories.length > 0,
          selectedIds: resource_influence_categories,
        },
        view: {
          ...currentFilters?.contentBasedFilter?.selectedObjects?.view,
          active: min_view || max_view,
          max: max_view,
          min: min_view,
        },
      },
      hasFilter:
        resource_influence_categories.length > 0 || min_view || max_view,
    };
  }

  return {
    stream: finalStream,
    filters: {
      ...dashboardInitialState.filters,
      [platform]: {
        ...currentFilters,
        ...finalFilters,
      },
    },
  };
};
